import {localize} from '@/utils/i18n'

export const useLocalize = () => {
    const text = {
        prodButton: localize({
            ru: 'Каталог продукции',
            en: 'All products'
        }),
        consultTitle: localize({
            ru: 'Заинтересованы<br>в&nbsp;сотрудничестве?',
            en: 'Are you interested in&nbsp;cooperation?'
        }),
        consultText: localize({
            ru: 'Проконсультируйтесь<br>по&nbsp;ассортименту и&nbsp;срокам поставки.',
            en: 'Ask for advice on&nbsp;the product range and delivery dates.'
        }),
        slider: [
            {
                text: localize({
                    ru: 'Оптовая продажа сортового металлопроката строительного и&nbsp;промышленного назначения, ванадиевой продукции в&nbsp;РФ и&nbsp;странах ближнего зарубежья',
                    en: 'We&nbsp;sell: construction rolled steel, hardware, high quality vanadium products. All products are certified and comply with GOST.'
                })
            },
            {
                text: localize({
                    ru: 'Оптовая продажа сортового металлопроката строительного и&nbsp;промышленного назначения, ванадиевой продукции в&nbsp;РФ и&nbsp;странах ближнего зарубежья',
                    en: 'We&nbsp;sell: construction rolled steel, hardware, high quality vanadium products. All products are certified and comply with GOST.'
                })
            },
            {
                text: localize({
                    ru: 'Оптовая продажа сортового металлопроката строительного и&nbsp;промышленного назначения, ванадиевой продукции в&nbsp;РФ и&nbsp;странах ближнего зарубежья',
                    en: 'We&nbsp;sell: construction rolled steel, hardware, high quality vanadium products. All products are certified and comply with GOST.'
                })
            },
            {
                text: localize({
                    ru: 'Оптовая продажа сортового металлопроката строительного и&nbsp;промышленного назначения, ванадиевой продукции в&nbsp;РФ и&nbsp;странах ближнего зарубежья',
                    en: 'We&nbsp;sell: construction rolled steel, hardware, high quality vanadium products. All products are certified and comply with GOST.'
                })
            },
            {
                text: localize({
                    ru: 'Оптовая продажа сортового металлопроката строительного и&nbsp;промышленного назначения, ванадиевой продукции в&nbsp;РФ и&nbsp;странах ближнего зарубежья',
                    en: 'We&nbsp;sell: construction rolled steel, hardware, high quality vanadium products. All products are certified and comply with GOST.'
                })
            }
        ]
    }

    return {text}
}
